<template>
  <div id="xy_ss" class="setPad">
    <topNav :title="title"></topNav>

    <!--列表-->
    <div class="list-shell relativeItem">
      <!--搜索框-->
      <div class="search flex-box relativeItem">
        <input
          type="text"
          v-model="search_word"
          @focus="on_focus"
          placeholder="搜索主播昵称/朱贝号"
        />
        <span
          class="close_btn absoluteItem centerY"
          @click="close_search"
          v-if="show_close_search"
        >
          <img src="../../assets/tip(2).png" class="imgBlock noevents-img" />
        </span>

        <span class="s-btn flex-box" @click="click_search">搜索</span>
      </div>

      <!--标题-->
      <div class="title flex-box">
        <span>头像</span>
        <span>主播昵称</span>
        <span>心愿</span>
      </div>

      <!--列表数据-->
      <ul id="lists" class="relativeItem">
        <li
          class="flex-box relativeItem"
          :class="{ no_p_left: is_searching }"
          v-for="(n, index) in ul_list"
          :key="index"
          v-show="ul_list.length > 0 && !show_blank"
        >
          <a class="allA" :data-uid="n.user_id" @click="linkto"></a>
          <div class="d1">
            <div class="head relativeItem">
              <img
                :src="n.heade_portrait"
                class="head-img imgBlock noevents-img"
                onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
              />
            </div>
          </div>
          <div class="d2 apostrophe">{{ n.user_name }}</div>
          <div class="d3">{{ n.gift_name }}</div>
        </li>

        <!--空白列表-->
        <p class="blank absoluteItem centerImg" v-if="show_blank">
          <img
            src="../../assets/xyuan/blankimg.png"
            class="imgBlock noevents-img"
          />
          <span>没有相关主播信息</span>
        </p>
      </ul>

      <!--版权说明-->
      <p class="copyright">活动最终解释权归朱贝所有</p>
    </div>
  </div>
</template>












<script>
import topNav from "./topNav";

export default {
  name: "xy_ss",
  components: {
    topNav,
  },
  data() {
    return {
      search_word: "", //用户搜索显示的关键字
      in_search_word: "", //传给接口的关键字
      show_blank: false, //数据是否为空
      list_more: true,
      search_list_more: true,
      ul_list: [], //用于列表展示的数据
      list: [],
      page: 1,
      search_page: 1, //搜索列表的页码
      search_list: [], //搜索列表数据
      is_searching: false, //判断当前列表是否为搜索列表
      show_close_search: false, //是否显示关闭搜索列表的按钮
      none_text: "暂无排名",
      title: "发送心愿",
      // idName: "#xy_ss",
    };
  },
  methods: {
    // 后退
    goBack() {
      this.$router.go(-1);
    },
    /**点击跳转 */
    linkto(e) {
      let _this = this;
      this.$appAc.to_liveroom({ userid: e.target.dataset.uid });
      //设置定时器在app打开直播间之后再打开礼物列表
      setTimeout(() => {
        _this.send_gift();
      }, 4000);
    },

    /**打开礼物列表 */
    send_gift() {
      let data = {
        ios: {
          app_open: "openGiftList",
          jumpurl: "",
        },
        android: {
          app_open: "openGiftList",
          url: "",
        },
      };
      this.$appAc.actionAsPhp(data);
    },

    /**列表滚动事件 */
    scroll_event() {
      let item = document.querySelector("#lists");
      let _this = this;
      let utop,
        sHeight,
        cheight = null;
      item.addEventListener("scroll", (e) => {
        (utop = e.target.scrollTop),
          (sHeight = e.target.scrollHeight),
          (cheight = e.target.clientHeight);
        if (
          sHeight - (utop + cheight) <= 100 &&
          _this.list_more &&
          !_this.is_searching
        ) {
          _this.list_more = false;
          _this.page++;
          _this.get_list();
        } else if (
          sHeight - (utop + cheight) <= 100 &&
          _this.search_list_more &&
          _this.is_searching
        ) {
          _this.search_list_more = false;
          _this.search_page++;
          _this.search_person();
        }
      });
    },

    /**请求列表 */
    get_list() {
      let _this = this;
      let data = { page: this.page, pagesize: 15 };
      this.$jsonp(this.$apis("xy_ss"), data, (res) => {
        let ls = res.data.data;
        if (ls.length != 0) {
          //有数据
          if (_this.page == 1) {
            _this.list = ls;
            _this.ul_list = ls;
            setTimeout(() => {
              _this.scroll_event();
            }, 500);
          } else {
            _this.list = _this.list.concat(ls);
            _this.ul_list = _this.ul_list.concat(ls);
          }
          _this.list_more = true;
        } else {
          //没数据
          if (_this.page == 1) {
            _this.show_blank = true;
          }
        }
      });
    },

    /**请求列表 */
    get_vote_num() {
      let _this = this;
      this.$jsonp(this.$apis("gnj_list_vote_num"), {}, (res) => {
        _this.vote_num = res.data.data.num;
        _this.ac_status = res.data.data.running;
      });
    },

    /**取消搜索 */
    close_search() {
      this.is_searching = false;
      this.search_page = 1;
      this.search_list = [];
      this.show_blank = false;
      this.show_close_search = false;
      this.ul_list = this.list;
      this.search_word = "";
      this.in_search_word = "";
      this.none_text = "暂无排名";
    },

    /**input获取焦点时 */
    on_focus(e) {
      setTimeout(() => {
        e.target.value = this.in_search_word;
      }, 500);
    },

    /**点击搜索触发的方法 */
    click_search(e) {
      e.target.classList.add("click-btn");
      this.in_search_word = this.search_word;
      this.search_page = 1;
      this.search_list_more = true;
      this.search_list = [];
      this.search_person();
      setTimeout(() => {
        e.target.classList.remove("click-btn");
      }, 600);
    },

    /**搜索 */
    search_person() {
      // if (this.show_blank) {
      //   return false;
      // }
      if (this.search_word == "") {
        this.close_search();
        return false;
      }

      this.is_searching = true;
      let _this = this;
      let data = {
        page: this.search_page,
        keywords: this.search_word,
        pagesize: 15,
      };
      _this.show_close_search = true;
      this.$jsonp(this.$apis("xy_ss"), data, (res) => {
        let ls = res.data.data;
        if (ls.length != 0) {
          //有数据
          if (_this.search_page == 1) {
            _this.search_list = ls;
            _this.ul_list = ls;
          } else {
            _this.search_list = _this.search_list.concat(ls);
            _this.ul_list = _this.ul_list.concat(ls);
          }
          _this.search_list_more = true;
        } else {
          //没数据
          if (_this.search_page == 1) {
            _this.show_blank = true;
            _this.none_text = "没有此用户";
          }
        }
      });
    },

    // 设置顶部的内置padding
    setTopPad() {
      let topNavHt = document.querySelector(".top_nav").offsetHeight;
      document.querySelector(".setPad").style.paddingTop = topNavHt + "px";
      document.querySelector(".list-shell").style.minHeight = "calc(100vh -" + ' ' + topNavHt + "px)";
    },
  },
  mounted() {
    this.$tool.setTitle("发送心愿");
    this.get_list();
    this.setTopPad();
  },
};
</script>













<style scoped>
#xy_ss {
  min-height: 100vh;
  background: #fff;
}

/**列表区域 */
.list-shell {
  width: 100%;
  margin: 0 auto;
  padding-top: 14px;
  margin-bottom: 14px;
  background: #3c044b;
}

.search {
  width: 92%;
  margin: 0 auto;
  margin-bottom: 12px;
  align-items: center;
}
.search input {
  width: 86%;
  height: 2.0625rem;
  background: url("../../assets/xyuan/search.png") 9px center no-repeat #540e90;
  background-size: 16px 16px;
  color: #fff;
  font-size: 0.8125rem;
  padding-left: 30px;
  padding-right: 9%;
  border-radius: 3rem;
}
input::-webkit-input-placeholder {
  color: #9479b6;
}
input:-moz-placeholder {
  color: #9479b6;
}
input::-moz-placeholder {
  color: #9479b6;
}
.close_btn {
  width: 16px;
  right: 22%;
  z-index: 2;
  margin: 0;
}
.s-btn {
  float: right;
  width: 24%;
  height: 100%;
  border-radius: 3rem;
  font-size: 1rem;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.click-btn {
  opacity: 0.5;
}

/**列表标题 */
.title {
  position: relative;
  width: 92%;
  justify-content: space-between;
  border-radius: 5px;
  background: #540e90;
  margin: 0 auto;
  margin-bottom: 5px;
}
.title::after,
.title::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 100%;
  background: #42007a;
  top: 0;
}
.title::after {
  right: 33.333333%;
}
.title::before {
  left: 33.333333%;
}
.title span {
  display: inline-block;
  width: 33.333333%;
  text-align: center;
  padding: 6px 0;
  color: #ffecb3;
  font-size: 0.75rem;
}

.list-shell .num {
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #fff;
}
.waiting {
  color: #fff;
  text-align: center;
}
.waiting img {
  width: 65px;
  margin: 0 auto;
}
.waiting .p1 {
  font-size: 15px;
  margin-top: 11px;
}
.waiting .p2 {
  font-size: 14px;
  margin-top: 5px;
}

#lists {
  width: 92%;
  margin: 0 auto;
  height: 60vh;
  overflow-y: scroll;
}
#lists li {
  width: 100%;
  background: url("../../assets/xyuan/21(28).png") center center no-repeat;
  background-size: 100% 100%;
  padding: 14px 0;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
}
#lists li:last-child {
  margin-bottom: 0;
}
/* #lists .no_p_left {
  padding-left: 12px;
} */
#lists .tp-btn {
  width: 23%;
  right: 19px;
  transform: translateY(-40%);
}
#lists .rank {
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  left: 12px;
  top: 50%;
  transform: rotateZ(5deg) translateY(-50%);
}
#lists .rank::after {
  position: absolute;
  content: "";
  width: 12px;
  height: 1px;
  background: #fff;
  top: 50%;
  transform: translateY(-50%) rotateZ(-5deg);
  right: -16px;
}
#lists .n-rank {
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  left: 12px;
}
#lists .head {
  margin: 0 auto;
  width: 3.4375rem;
  height: 3.4375rem;
  border-radius: 50%;
  padding: 2px;
  background: linear-gradient(to bottom, #ff4683, #fffbb2);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
#lists .head .head-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
#lists div {
  width: 33%;
}
#lists .d2 {
  padding: 0 4px;
  font-size: 0.9375rem;
  color: #fff;
  text-align: center;
}
#lists .d3 {
  padding: 0 9px;
  font-size: 0.6875rem;
  color: #fff495;
  text-align: center;
}
.copyright {
  font-size: 0.5625rem;
  color: #75288a;
  text-align: center;
  margin-top: 12px;
  padding: 0 0 20px;
}

/**空白标识 */
.blank {
  width: 100%;
  font-size: 14px;
  color: #fff;
  text-align: center;
}
.blank img {
  width: 9.1875rem;
  margin: 0 auto;
  margin-bottom: 10px;
}
</style>
